import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft, User, Baby } from "lucide-react";

export default function ParentBaby() {
  const nav = useNavigate();
  return (
    <div className="animate-fade-in pt-6">
      <button data-testid="back-btn" onClick={() => nav(-1)} className="flex items-center gap-1 text-[color:var(--ivoire-muted)] text-sm mb-4">
        <ChevronLeft size={16} /> Retour
      </button>
      <h1 className="font-serif text-3xl text-[color:var(--ivoire)]">Parent et bébé</h1>
      <p className="text-sm text-[color:var(--ivoire-muted)] mt-2">
        Deux façons d'utiliser cet espace.
      </p>

      <div className="mt-8 grid gap-4">
        <Link
          to="/personnaliser"
          data-testid="baby-adult-btn"
          className="rounded-2xl border border-[color:var(--border)] bg-[#142235]/80 p-6 hover:bg-[#1B2A3E] transition"
        >
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-[color:var(--sauge)]/15 flex items-center justify-center">
              <User className="text-[color:var(--sauge-light)]" size={22} strokeWidth={1.4} />
            </div>
            <div>
              <h2 className="font-serif text-xl text-[color:var(--ivoire)]">Me détendre en tant que parent</h2>
              <p className="text-xs text-[color:var(--ivoire-muted)] mt-1">Accès aux séances adultes.</p>
            </div>
          </div>
        </Link>

        <Link
          to="/bebe/ambiance"
          data-testid="baby-ambient-btn"
          className="rounded-2xl border border-[color:var(--border)] bg-[#142235]/80 p-6 hover:bg-[#1B2A3E] transition"
        >
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-[color:var(--sauge)]/15 flex items-center justify-center">
              <Baby className="text-[color:var(--sauge-light)]" size={22} strokeWidth={1.4} />
            </div>
            <div>
              <h2 className="font-serif text-xl text-[color:var(--ivoire)]">Ambiance sonore pour bébé</h2>
              <p className="text-xs text-[color:var(--ivoire-muted)] mt-1">Sons doux avec minuteur.</p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
